<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>资源详情</h1>
        <span class="icon-right pull-right img-fav active" v-if="infoStatus.myCountS == 1"  @click="callcollectionZx()">取消收藏</span>
        <span class="icon-right pull-right img-fav" v-else @click="collectionZx()">收藏</span>
      </div>
      <div class="liner"></div>
    </div>



    <div class="main-page bg-white" style="min-height:600px">

      <div class="padding-15" id="myIframe">
      </div>
    </div>
  </div>
</template>

<script>
import { service } from '../../service'
import { Toast } from 'mint-ui'
export default {
  data () {
    return {
      detailId: 0,
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      get_detail_status_para: service.setPara('getContenteOtherDetail'),
      information_save_para: service.setPara('collectionZx'), // 收藏资源
      infocontent_cancel_para: service.setPara('callcollectionZx'), // 取消资源
      info: {},
      infoStatus: {},
      opUserId: 0,
      opUserRole: 'teacher'
    }
  },
  mounted: function () {
    this.opUserId = this.cookie_login_data.teacherId
    if (this.detailId != this.$route.params.detailId) {
      this.detailId = this.$route.params.detailId
      this.getContenteOtherDetail()
      $('#myIframe iframe').remove()
      var that = this
      Vue.nextTick(function () {
        $('#myIframe').html('<iframe id="myIframe" width="100%" frameborder="0" height="' + $(window).height() + '" src="' + 'http://www.shurenapp.com/vma-trusttee/tinfocontent/infoContentDetail?contentId=' + that.detailId + '"></iframe>')
      })
    }
  },
  methods: {
    getContenteOtherDetail: function () {
      this.opUserId = this.cookie_login_data.teacherId
      this.get_detail_status_para.opUserId = this.opUserId
      this.get_detail_status_para.opUserRole = this.opUserRole
      this.get_detail_status_para.contentId = this.detailId

      let that = this
      let obj = {context: this, para: this.get_detail_status_para, successFun: (response) => {
        that.infoStatus = response.data
      }}
      service.request(obj)
    },
    collectionZx: function () { // 收藏资源
      this.information_save_para.contentId = this.detailId
      this.information_save_para.opUserId = this.opUserId
      this.information_save_para.opUserRole = this.opUserRole

      let that = this
      let obj = {context: this, para: this.information_save_para, successFun: (response) => {
        that.infoStatus.myCountS = 1
        Toast('收藏成功')
      }}
      service.request(obj)
    },
    callcollectionZx: function () { // 取消收藏资源
      this.infocontent_cancel_para.contentId = this.detailId
      this.infocontent_cancel_para.opUserId = this.opUserId
      this.infocontent_cancel_para.opUserRole = this.opUserRole

      let that = this
      let obj = {context: this, para: this.infocontent_cancel_para, successFun: (response) => {
        that.infoStatus.myCountS = 0
        Toast('取消成功')
      }}
      service.request(obj)
    }
  }
}
</script>




// WEBPACK FOOTER //
// InformationDetail.vue?08aceaac